import { useCallback, useImperativeHandle, useState } from 'react';
export function useSinglePanelAccordionController(ref, _a) {
    var onPanelChanged = _a.onPanelChanged;
    var _b = useState(), currentOpen = _b[0], setCurrentOpen = _b[1];
    var getIsOpen = useCallback(function (id) {
        return id === currentOpen;
    }, [currentOpen]);
    var setIsOpen = useCallback(function (id) {
        setCurrentOpen(function (open) {
            if (id === open) {
                onPanelChanged && onPanelChanged(undefined);
                return undefined;
            }
            onPanelChanged && onPanelChanged(id);
            return id;
        });
    }, [onPanelChanged]);
    useImperativeHandle(ref, function () { return ({
        open: function (id) {
            setCurrentOpen(id);
            onPanelChanged && onPanelChanged(id);
        },
        close: function (id) {
            if (getIsOpen(id)) {
                setCurrentOpen(undefined);
                onPanelChanged && onPanelChanged(undefined);
            }
        },
        closeAll: function () {
            setCurrentOpen(undefined);
            onPanelChanged && onPanelChanged(undefined);
        },
    }); }, [getIsOpen, onPanelChanged]);
    return { getIsOpen: getIsOpen, setIsOpen: setIsOpen };
}
//# sourceMappingURL=useSinglePanelAccordionController.js.map